






import { getAntDatePickerLocale } from '@/i18n/dateLocale';
import moment, { Moment } from 'moment';

export default {
  name: "date-picker",
  props: {
    size: String,
    dateRange: {
      type: Array,
      default: null
    },
  },
  data() {
    return {
      moment,
    };
  },
  methods: {
    onChange(date: any, dateString: string[]) {
      // @ts-ignore
      this.$emit('change', dateString)
    },
  },
  computed: {
    antLocale() {
      return getAntDatePickerLocale();
    },
    defaultValue(): Moment[] {
      // @ts-ignore
      if (!this.dateRange) {
        return [];
      }
      // @ts-ignore
      return this.dateRange.map((date: any) => this.moment(date, 'YYYY-MM-DD'));
    }
  },
};
